<template>
  <div class="min-h-screen bg-gray-50">
    <slot />
    <ToastContainer />
  </div>
</template>
